module.exports = __webpack_public_path__ + "static/media/30.bcf4d16a.webp";